export default {
  getOrgList: process.env.BASE_URL + '/api/modules/mobile/org',
  getActivityList: process.env.BASE_URL + '/api/modules/mobile/activity',
  activityDetail: process.env.BASE_URL + '/api/modules/mobile/detail',
  userInfo: process.env.BASE_URL + '/api/modules/mobile/userInfo'
}